// extracted by mini-css-extract-plugin
module.exports = {"list":"components-LocationsList-___LocationsList__list___2NB3J"};